import React, { forwardRef } from 'react';
import { string, bool, func } from 'prop-types';
import { translate, I18n } from '@fiverr-private/i18n-react';
import { FormInput } from '../../../../shared/FormInput';
import { STATUS } from '../../services/emailAvailability';
import { EMAIL_VALIDATION } from '../../fields/email';
import { LoginLink } from '../../../../shared/LoginLink';

const emailErrorMessage = (reason) => {
    switch (reason) {
        case STATUS.TAKEN:
        case STATUS.SERVICE_ERROR:
            return emailNotAvailable();
        case EMAIL_VALIDATION.REGEXP:
        default:
            return translate('affiliates_signup_perseus.errors.email');
    }
};

const emailNotAvailable = () => {
    const templates = {
        login: (label) => <LoginLink>{label}</LoginLink>,
    };

    return <I18n k="affiliates_signup_perseus.errors.email_na" templates={templates} />;
};

export const Email = forwardRef((props, ref) => {
    const { value, onFocus, onChange, onBlur, valid, dirty, pending, reason } = props;

    return (
        <FormInput
            value={value}
            type="email"
            onFocus={onFocus}
            onChange={onChange}
            onBlur={onBlur}
            valid={valid}
            dirty={dirty}
            pending={pending}
            placeholder={translate('affiliates_signup_perseus.personal_info.email')}
            isRequired
            ref={ref}
            autoComplete="email"
            errorMessage={emailErrorMessage(reason)}
        />
    );
});

Email.displayName = 'Email';

Email.propTypes = {
    value: string,
    reason: string,
    onFocus: func,
    onChange: func,
    onBlur: func,
    valid: bool,
    dirty: bool,
    pending: bool,
};
